import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Card from "../../component/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import img from "../../assets/main/1.jpg";
const Clients = () => {
  const { t } = useTranslation();
  const { arrivals, loading } = useSelector((state) => state.homeSlicer);

  return (
    <section className="flat-client">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="client-content-box wow fadeInUp">
              <h4 className="section-subtitle">Client's Feedback</h4>
              <h2 className="section-title section-45px-montserrat">
                Clients Love
              </h2>
              <p className="margin-bottom-30">
                Fusce consectetur erat id enim elementum tincidunt. Vestibulum
                accumsan elementum leo, et viverra justo ultricies ac. Vivamus
                quis dolor ac orci tempus ornare. In volutpat vitae ligula vitae
                lacinia.
              </p>
              <div className="brand-client wow fadeInLeft">
                <span>
                  <img
                    src="assets/images/brand/brand-client-1.png"
                    alt="Client Brand 1"
                  />
                </span>
                <span>
                  <img
                    src="assets/images/brand/brand-client-2.png"
                    alt="Client Brand 2"
                  />
                </span>
              </div>
              <button className="clone-btn-prev"></button>
              <button className="clone-btn-next"></button>
            </div>
          </div>
          <div className="col-md-6">
            <Swiper
              modules={[Navigation]}
              direction="vertical"
              spaceBetween={20}
              slidesPerView={3}
              centeredSlides={true}
              loop={true}
              navigation={{
                nextEl: ".clone-btn-next",
                prevEl: ".clone-btn-prev",
              }}
              className="sliver-vertical"
            >
              {[...Array(5)].map((_, index) => (
                <SwiperSlide key={index}>
                  <div className="client-slider-box">
                    <div className="client-user">
                      <img src={img} alt={`Client ${index + 1}`} />
                    </div>
                    <div className="client-content">
                      <div className="client-user-author">
                        <h4 className="name-author section-20px-montserrat">
                          Brade Hook
                        </h4>
                        <p className="margin-top-11">
                          A customer review is a review of a product or service
                          made by a customer who has purchased and used, or had
                          experience with, the product or service.
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
